import api from './api';

export interface MfaStatus {
  enabled: boolean;
  backupCodesRemaining: number;
}

export interface MfaSetupResponse {
  secret: string;
  otpauthUrl: string;
  qrCodeDataUrl: string;
}

export interface MfaVerifySetupResponse {
  success: boolean;
  backupCodes: string[];
}

export async function getMfaStatus(): Promise<MfaStatus> {
  const res = await api.get('/auth/mfa/status');
  return res.data;
}

export async function setupMfa(): Promise<MfaSetupResponse> {
  const res = await api.post('/auth/mfa/setup');
  return res.data;
}

export async function verifyMfaSetup(secret: string, code: string): Promise<MfaVerifySetupResponse> {
  const res = await api.post('/auth/mfa/verify-setup', { secret, code });
  return res.data;
}

export async function disableMfa(code: string): Promise<{ success: boolean }> {
  const res = await api.delete('/auth/mfa', { data: { code } });
  return res.data;
}

export async function verifyMfaLogin(sessionToken: string, code: string) {
  const res = await api.post('/auth/verify-mfa', { session_token: sessionToken, code });
  return res.data;
}
